import * as React from 'react';
import { cn } from '@/shared/lib/utils';
import { themed } from './themed';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

/** Themed shadcn-style text input. */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        themed.field.base,
        themed.field.border,
        themed.focusRing,
        'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[var(--text-primary)]',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
